// generated file, if you want to edit this file manually change the word "generated" to "manual"

import { isVariantEnabled, makeThemedStyles } from '@qpr/components/utils';
import clsx from 'clsx';
import React from 'react';

const useStylesForKPIToolBarMenuItem = makeThemedStyles(
  'KPIToolBarMenu.KPIToolBarMenuItem',
  () => ({
    KPIToolBarMenuItem: {
      padding: '1em',
      borderBottom: '3px solid #115e67',
      textTransform: 'uppercase',
      paddingLeft: '1.5em',
      paddingRight: '1.5em',
      '&:hover': { textDecoration: 'underline' }
    },

    active: {
      backgroundColor: '#deeceb'
    }
  })
);

type ElementProps = React.ComponentProps<React.HTMLFactory<HTMLElementTagNameMap['div']>>;

export const KPIToolBarMenuItem: React.FunctionComponent<ElementProps> = (props: ElementProps) => {
  const styles = useStylesForKPIToolBarMenuItem();

  /* eslint-disable */
  return (
    <div
      {...props}
      style={{ ...(props?.style || {}), ...{} }}
      className={clsx(styles.KPIToolBarMenuItem, {
        [styles.active]: isVariantEnabled(props, 'active')
      })}
    >
      {props?.children}
    </div>
  );
};
export default KPIToolBarMenuItem;
